import React from 'react'
import PropTypes from 'prop-types'

export const Line = ({ width, height, color }) => {
  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        marginBottom: '10px',
      }}
    >
      <div
        style={{
          backgroundColor: color,
          width,
          height,
        }}
      ></div>
    </div>
  )
}

Line.propTypes = {
  width: PropTypes.string,
  height: PropTypes.string,
  color: PropTypes.string,
}

Line.defaultProps = {
  width: '15px',
  height: '4px',
  color: '#F6236D',
}

export default Line
